import axios from 'axios'
import { ConfigProd as config, fb as firebase } from './config'

const http = axios.create({
  baseURL: config.baseURL,
  timeout: 20000,
  headers: { Authorization: `Bearer ${config.token}` }
})

const parseData = ({ data, error }) => {
  if (data) {
    return data
  }
  throw new Error(error.message)
}

const getMethod = url => http.get(url).then(res => parseData(res.data))
const postMethod = (url, body) =>
  http.post(url, body).then(res => parseData(res.data))

export class SandeeApi {
  static getHeader() {
    return getMethod('/resources/information')
  }

  static getMainContent() {
    return getMethod('/home/content')
  }

  static getProject(slug) {
    return getMethod(`/project/${slug}`)
  }

  static getPromotion(id) {
    const hasLastId = (id && `?last_id=${id}`) || ''
    return getMethod(`/promotion${hasLastId}`)
  }

  static getPastProjects() {
    return getMethod('/pastProjects')
  }

  static getAboutUsInfo() {
    return getMethod('/resources/aboutus')
  }

  static getContactInfo() {
    return getMethod('/resources/contact')
  }

  static sendRepairInfo(info) {
    return postMethod('/service/support', info)
  }

  static sendRequestInfo(info) {
    return postMethod('/service/request', info)
  }

  static sendOfferInfo(info, file) {
    const metadata = {
      contentType: file.type
    }
    const fileName = getEncodedFileName(file.name)
    return firebase
      .storage()
      .ref()
      .child(`files/${fileName}`)
      .put(file, metadata)
      .then(snapshot => {
        return snapshot.ref.getDownloadURL()
      })
      .then(url => {
        return postMethod('service/offer', {
          ...info,
          file: {
            name: fileName,
            url
          }
        })
      })
  }

  static sendEmail(info) {
    return postMethod('/email/send', info)
  }
}

function getEncodedFileName(name) {
  const f = name.split('.')
  const extension = f[f.length - 1]
  const fileName = `${f.slice(0, f.length - 1)}_${Date.now()}`
  return `${fileName}.${extension}`
}
